var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VRow',[_c('VCol',{attrs:{"cols":"12"}},[_c('VCard',{staticClass:"mx-auto"},[_c('VCardText',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('venue.sanifair')))]),_c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items,"initial-values":_vm.initVals}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }